(function () {
  var cfgEl = document.getElementById('ol-cart-config');
  var root = document.getElementById('ol-cart-drawer');
  if (!cfgEl || !root) return;
  var cfg = JSON.parse(cfgEl.textContent);
  var list = root.querySelector('[data-olc-list]');
  var empty = root.querySelector('[data-olc-empty]');
  var foot = root.querySelector('[data-olc-foot]');
  var subEl = root.querySelector('[data-olc-sub]');
  var saveRow = root.querySelector('[data-olc-save]');
  var saveEl = root.querySelector('[data-olc-saving]');
  var cta = root.querySelector('[data-olc-checkout]');
  var panel = root.querySelector('.olc__panel');
  var busy = false;
  var lastFocus = null;

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents, cur) {
    try { return new Intl.NumberFormat('de-DE', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' ' + cur; }
  }
  function json(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function isExtra(id) { return cfg.extras.indexOf(id) !== -1; }

  function mainQty(cart) {
    return cart.items.reduce(function (n, i) { return i.variant_id === cfg.main ? n + i.quantity : n; }, 0);
  }

  function sync(cart) {
    var want = mainQty(cart);
    var updates = {};
    var need = false;
    cfg.extras.forEach(function (id) {
      if (!id) return;
      var have = cart.items.reduce(function (n, i) { return i.variant_id === id ? n + i.quantity : n; }, 0);
      if (have !== want) { updates[id] = want; need = true; }
    });
    if (!need) return Promise.resolve(cart);
    return json('/cart/update.js', { updates: updates }).then(function (c) { return c && c.items ? c : cart; });
  }

  function count(cart) {
    document.querySelectorAll('.ol-header__count').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  }

  function sorted(cart) {
    var rank = function (i) {
      if (i.variant_id === cfg.main) return 0;
      var k = cfg.extras.indexOf(i.variant_id);
      return k === -1 ? 1 : 2 + k;
    };
    return cart.items.slice().sort(function (a, b) { return rank(a) - rank(b); });
  }

  function img(i) {
    var u = i.featured_image && i.featured_image.url ? i.featured_image.url : i.image;
    if (!u) return '';
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=240';
  }

  function render(cart) {
    count(cart);
    var items = sorted(cart);
    var has = items.length > 0;
    empty.hidden = has;
    foot.hidden = !has;
    list.innerHTML = items.map(function (i) {
      var extra = isExtra(i.variant_id);
      var free = i.final_line_price === 0 && i.original_line_price > 0;
      var disc = i.final_line_price < i.original_line_price;
      var price = '';
      if (free) price = '<span class="olc__was">' + money(i.original_line_price, cart.currency) + '</span><span class="olc__free">GRATIS</span>';
      else if (disc) price = '<span class="olc__was">' + money(i.original_line_price, cart.currency) + '</span>' + money(i.final_line_price, cart.currency);
      else price = money(i.final_line_price, cart.currency);
      var variant = i.variant_title && i.variant_title !== 'Default Title' ? '<p class="olc__var">' + esc(i.variant_title) + '</p>' : '';
      var ctrl = extra ? '' :
        '<div class="olc__ctrl"><div class="olc__qty"><button type="button" data-olc-minus="' + i.key + '" data-qty="' + i.quantity + '" aria-label="Weniger">&minus;</button><span>' + i.quantity + '</span><button type="button" data-olc-plus="' + i.key + '" data-qty="' + i.quantity + '" aria-label="Mehr">+</button></div>' +
        '<button type="button" class="olc__del" data-olc-del="' + i.key + '" aria-label="Entfernen"><svg viewBox="0 0 24 24"><path d="M5 7h14M10 7V4.5h4V7M7 7l.8 12.5h8.4L17 7M10.5 11v5M13.5 11v5"/></svg></button></div>';
      var src = img(i);
      return '<li class="olc__item"><div>' + (src ? '<img class="olc__img" src="' + esc(src) + '" alt="' + esc(i.product_title) + '" width="80" height="80">' : '<div class="olc__img"></div>') + '</div>' +
        '<div><p class="olc__name">' + esc(i.product_title) + (extra && i.quantity > 1 ? ' &times; ' + i.quantity : '') + '</p>' + variant + '</div>' +
        '<div class="olc__price">' + price + '</div>' + ctrl + '</li>';
    }).join('');
    subEl.textContent = money(cart.items_subtotal_price, cart.currency);
    var saved = cart.items.reduce(function (n, i) { return n + (i.original_line_price - i.final_line_price); }, 0);
    saveRow.hidden = saved <= 0;
    saveEl.textContent = '−' + money(saved, cart.currency);
    cta.setAttribute('aria-disabled', has ? 'false' : 'true');
  }

  function refresh() {
    return getCart().then(sync).then(function (c) { render(c); return c; });
  }

  function open() {
    lastFocus = document.activeElement;
    root.hidden = false;
    requestAnimationFrame(function () { root.classList.add('is-open'); panel.focus(); });
    document.body.classList.add('olc-lock');
    refresh();
  }
  function close() {
    root.classList.remove('is-open');
    document.body.classList.remove('olc-lock');
    setTimeout(function () { if (!root.classList.contains('is-open')) root.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function change(key, qty) {
    if (busy) return;
    busy = true;
    root.classList.add('is-busy');
    json('/cart/change.js', { id: key, quantity: qty }).then(function (c) { return sync(c); }).then(render).catch(function () {}).then(function () { busy = false; root.classList.remove('is-busy'); });
  }

  function addSet(qty) {
    var items = [];
    cfg.extras.slice().reverse().forEach(function (id) { if (id) items.push({ id: id, quantity: qty }); });
    items.push({ id: cfg.main, quantity: qty });
    return json('/cart/add.js', { items: items });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-olc-close],[data-olc-minus],[data-olc-plus],[data-olc-del],[data-ol-cart-open]') : null;
    if (!t) return;
    if (t.hasAttribute('data-ol-cart-open')) { e.preventDefault(); open(); return; }
    if (t.hasAttribute('data-olc-close')) { close(); return; }
    var q = parseInt(t.getAttribute('data-qty'), 10) || 1;
    if (t.hasAttribute('data-olc-minus')) change(t.getAttribute('data-olc-minus'), Math.max(0, q - 1));
    if (t.hasAttribute('data-olc-plus')) change(t.getAttribute('data-olc-plus'), q + 1);
    if (t.hasAttribute('data-olc-del')) change(t.getAttribute('data-olc-del'), 0);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    var idEl = f.querySelector('[name="id"]');
    if (!idEl || parseInt(idEl.value, 10) !== cfg.main) return;
    e.preventDefault();
    var btn = f.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;
    var qtyEl = f.querySelector('[name="quantity"]');
    addSet(qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1).then(function () {
      if (btn) btn.disabled = false;
      open();
    }).catch(function () { if (btn) btn.disabled = false; f.submit(); });
  }, true);

  window.olCart = { open: open, close: close, refresh: refresh, addSet: addSet };
})();
